import styled from '@emotion/styled'
import TableBody from '@mui/material/TableBody'

export const StyledTableBody = styled(TableBody)`
  background: var(--White98);
`
